const formatFileSize = (bytes) => {
    const kb = (bytes || 0) / 1024;
    return kb >= 1024 ? `${(kb / 1024).toFixed(2)} MB` : `${kb.toFixed(1)} KB`;
};
export default formatFileSize;
